import React, { Component } from "react";
import { Segment, Table, Button, Popup, Icon } from "semantic-ui-react";
import Page from "../../components/Page";
import Picker from "../../components/DateRangePicker";
import _ from "lodash";
import { post } from "../../util/api";
import { withTranslation } from "react-i18next";
import moment from "moment";
import "moment/locale/tr";

class AllProductsAnalytics extends Component {
  state = {
    loading: true,
    data: [],
    startDate: moment().subtract(1, "days").startOf("day"),
    endDate: moment().subtract(1, "days").endOf("day"),
    today: moment(),
    total_products: 0,
    products_with_data: 0,
    period_days: 1,
  };

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    try {
      this.setState({ loading: true });
      const { startDate, endDate } = this.state;

      const response = await post("/admin/analytics/all-products", {
        start_date: startDate.toISOString(),
        end_date: endDate.toISOString(),
      });

      if (response.data.success) {
        this.setState({
          data: response.data.data || [],
          total_products: response.data.total_products,
          products_with_data: response.data.products_with_data,
          period_days: response.data.period_days,
          loading: false,
        });
      } else {
        this.setState({ loading: false, data: [] });
      }
    } catch (error) {
      console.error("Analytics yükleme hatası:", error);
      this.setState({ loading: false, data: [] });
    }
  };

  dateChange = ({ selection }) => {
    let startDate = moment(selection.startDate).startOf("day");
    let endDate = moment(selection.endDate);

    if (
      endDate.format("YYYY-MM-DD") !== this.state.today.format("YYYY-MM-DD")
    ) {
      endDate = endDate.endOf("day");
    } else {
      endDate = moment();
    }

    this.setState({ startDate: startDate, endDate: endDate });
  };

  getNewData = () => {
    this.setState({ openPopup: false }, function () {
      this.loadData();
    });
  };

  renderChangeCell = (value, change) => {
    if (change === null || change === undefined) {
      return (
        <Table.Cell textAlign="right">
          <div>{value}</div>
          <div style={{ fontSize: "11px", color: "#999" }}>-</div>
        </Table.Cell>
      );
    }

    const changeNum = parseFloat(change);
    const isPositive = changeNum >= 0;
    const color = isPositive ? "#27ae60" : "#e74c3c";
    const icon = isPositive ? "↑" : "↓";

    return (
      <Table.Cell textAlign="right">
        <div style={{ fontWeight: "bold" }}>{value}</div>
        <div style={{ fontSize: "11px", color: color, fontWeight: "bold" }}>
          {icon} {Math.abs(changeNum).toFixed(2)}%
        </div>
      </Table.Cell>
    );
  };

  render() {
    const {
      data,
      loading,
      startDate,
      endDate,
      total_products,
      products_with_data,
      period_days,
    } = this.state;
    const { t, i18n } = this.props;
    const language = i18n.language === "en" ? "en" : "tr";

    if (loading) {
      return <Page.Loader />;
    }

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "calc(100vh - 90px)", // Üst menüler için yer bırak
          padding: "0",
        }}
      >
        {/* Header Kısmı - Sabit */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "15px",
            padding: "15px 20px",
            backgroundColor: "#f8f9fa",
            borderRadius: "4px",
            flexShrink: 0, // Header küçülmesin
          }}
        >
          <div>
            <strong style={{ fontSize: "16px" }}>
              {t("GiveChanceAnalytics") || "Reklam Kazanım Asistanı Analitiği"}
            </strong>
            <div style={{ fontSize: "13px", color: "#666", marginTop: "5px" }}>
              {products_with_data} / {total_products}{" "}
              {t("productsWithData") || "ürün"} • {period_days}{" "}
              {t("days") || "gün"}
            </div>
          </div>
          <Popup
            trigger={
              <Button
                primary
                content={
                  moment(startDate).locale(language).format("MMM DD, YYYY") +
                  " - " +
                  moment(endDate).locale(language).format("MMM DD, YYYY")
                }
                icon="calendar"
                labelPosition="left"
              />
            }
            content={
              <Picker
                dateChange={this.dateChange}
                startDate={startDate.toDate()}
                endDate={endDate.toDate()}
                lang={language}
                getNewData={this.getNewData}
              />
            }
            on="click"
            position="bottom right"
            flowing
          />
        </div>

        {/* Tablo Kısmı - Scrollable */}
        <div
          style={{
            flex: 1,
            overflow: "auto",
            border: "1px solid rgba(34,36,38,.15)",
            borderRadius: "4px",
          }}
        >
          <Table celled striped style={{ marginBottom: 0 }}>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                    backgroundColor: "#f9fafb",
                  }}
                >
                  {t("Brand") || "Marka"}
                </Table.HeaderCell>
                <Table.HeaderCell
                  textAlign="right"
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                    backgroundColor: "#f9fafb",
                  }}
                >
                  {t("TotalVisit") || "Toplam Ziyaret"}
                </Table.HeaderCell>
                <Table.HeaderCell
                  textAlign="right"
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                    backgroundColor: "#f9fafb",
                  }}
                >
                  {t("CaptureText") || "Yakalama"}
                </Table.HeaderCell>
                <Table.HeaderCell
                  textAlign="right"
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                    backgroundColor: "#f9fafb",
                  }}
                >
                  {t("CaptureRate") || "Yakalama %"}
                </Table.HeaderCell>
                <Table.HeaderCell
                  textAlign="right"
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                    backgroundColor: "#f9fafb",
                  }}
                >
                  {t("CategoryReturnText") || "Ara Sayfa Dönüş"}
                </Table.HeaderCell>
                <Table.HeaderCell
                  textAlign="right"
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                    backgroundColor: "#f9fafb",
                  }}
                >
                  {t("CategoryReturnRate") || "Dönüş %"}
                </Table.HeaderCell>
                <Table.HeaderCell
                  textAlign="right"
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                    backgroundColor: "#f9fafb",
                  }}
                >
                  {t("ProductReturnText") || "Ürün Geçiş"}
                </Table.HeaderCell>
                <Table.HeaderCell
                  textAlign="right"
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                    backgroundColor: "#f9fafb",
                  }}
                >
                  {t("ProductReturnRate") || "Geçiş %"}
                </Table.HeaderCell>
                <Table.HeaderCell
                  textAlign="right"
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                    backgroundColor: "#f9fafb",
                  }}
                >
                  {t("AddToCartText") || "Sepet"}
                </Table.HeaderCell>
                <Table.HeaderCell
                  textAlign="right"
                  style={{
                    position: "sticky",
                    top: 0,
                    zIndex: 10,
                    backgroundColor: "#f9fafb",
                  }}
                >
                  {t("AddToCartRate") || "Sepet %"}
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {data.length === 0 ? (
                <Table.Row>
                  <Table.Cell
                    colSpan="10"
                    textAlign="center"
                    style={{ padding: "40px" }}
                  >
                    <Icon name="inbox" size="huge" style={{ color: "#ccc" }} />
                    <div style={{ marginTop: "10px", color: "#999" }}>
                      {t("NoDataFound") ||
                        "Seçilen tarih aralığında veri bulunamadı"}
                    </div>
                  </Table.Cell>
                </Table.Row>
              ) : (
                data.map((item, index) => {
                  const metrics = item.metrics;
                  const changes = item.changes;

                  return (
                    <Table.Row key={index}>
                      <Table.Cell>
                        <strong>{item.product_name}</strong>
                      </Table.Cell>
                      {this.renderChangeCell(
                        metrics.totalVisit.toLocaleString(),
                        changes.totalVisit
                      )}
                      {this.renderChangeCell(
                        metrics.capture.toLocaleString(),
                        changes.capture
                      )}
                      {this.renderChangeCell(
                        "%" + metrics.captureRate,
                        changes.captureRate
                      )}
                      {this.renderChangeCell(
                        metrics.pageReturn.toLocaleString(),
                        changes.pageReturn
                      )}
                      {this.renderChangeCell(
                        "%" + metrics.returnRate,
                        changes.returnRate
                      )}
                      {this.renderChangeCell(
                        metrics.productReturn.toLocaleString(),
                        changes.productReturn
                      )}
                      {this.renderChangeCell(
                        "%" + metrics.productRate,
                        changes.productRate
                      )}
                      {this.renderChangeCell(
                        metrics.addToCart.toLocaleString(),
                        changes.addToCart
                      )}
                      {this.renderChangeCell(
                        "%" + metrics.cartRate,
                        changes.cartRate
                      )}
                    </Table.Row>
                  );
                })
              )}
            </Table.Body>
          </Table>
        </div>
      </div>
    );
  }
}

export default withTranslation()(AllProductsAnalytics);
